import React, { useCallback } from 'react';

import { useArticle } from '@/modules/corporate/modules/article/articleContext';
import { ArticleActions } from '@/modules/corporate/modules/article/enums';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';

import Header from './Header';
import { HeaderProps } from './types';

const HeaderContainer: React.FC<HeaderProps> = (props) => {
  const { headerState } = props;
  const { article, articleContent, isPreviewing, onAction } = useArticle();
  const isAdminRoute = useAdminRoute();

  const goBack = useCallback(() => onAction(ArticleActions.Back), [onAction]);

  return (
    <Header
      article={article}
      articleContent={articleContent}
      goBack={goBack}
      headerState={headerState}
      isAdminRoute={isAdminRoute}
      isPreviewing={isPreviewing}
    />
  );
};

export default React.memo(HeaderContainer);
